export default __webpack_public_path__ + "static/media/home-purple.2370eee4.svg";